<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    import { addMessage, BidForm, Button, SESSION_ORGANIZATION, SESSION_USER } from '@smatch/cassiopeia-web-components';

    // UTILITY
    import merge from 'deepmerge';
    import { DEFAULT, type Default } from 'src/app/routes/bids/pages/bid-form/config';

    // TYPES
    import type { Auction, Bid } from 'src/app/types';

    /* EXPORTS ----------------------------------------------------------------------------------- */

    export let auction: Auction;
    export let css = 'ml-1';

    /* INTERNALS -------------------------------------------------------------------------------- */

    const RESERVED_BID: Partial<Bid> = {};

    const overwriteMerge = (destinationArray: [], sourceArray: []): [] => sourceArray;

    const joinWaitingList = (): void => {

        addMessage({
            description: 'You have been added to the waiting list for this deal.',
            heading: 'Joined Waiting List',
            type: 'success',
        });
    };

    const BID: Default = merge.all([
        DEFAULT,
        RESERVED_BID,
        {
            auctionKey: auction._.key,
            buyer: {
                organizationKey: $SESSION_ORGANIZATION!._.key,
                ownerKey: $SESSION_USER!._.key,
            },
        },
    ], { arrayMerge: overwriteMerge }) as Default;

    const BUYER = BID.buyer;

    const beforeSave = (): void => {
        BUYER.description = 'I am interested in more deals like this.';
    };

</script>

<BidForm
    on:save
    on:save = {joinWaitingList}
    { beforeSave }
    action='create'
    bid = { BID }
>
    <Button
        { css }
        label = { 'Join waiting List' }
        type = 'submit'
        icon = 'arrowRight'
        color = 'quaternary'
    />
</BidForm>